import { render, staticRenderFns } from "./helpful-feedback.vue?vue&type=template&id=1de8241a&scoped=true&"
import script from "./helpful-feedback.vue?vue&type=script&lang=js&"
export * from "./helpful-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8241a",
  null
  
)

export default component.exports